import AssetService from '../../services/assets';
import i18n from '../../i18n'

const namespaced = true;

const actions = {
  async bulkUpload({ }, { siteId, formData }) {
    try {
      const response = await AssetService.bulkUpload(siteId, formData);
      return response;
    } catch (e) {
      // The axios interceptor returns error.response directly, not the full error
      // So we need to check for both e.response.data and e.data
      if (e.response && e.response.data) {
        // Standard Axios error structure
        throw {
          status: e.response.status,
          data: e.response.data
        };
      } else if (e.data && e.status) {
        // Error already transformed by axios interceptor
        throw {
          status: e.status,
          data: e.data
        };
      }
      // Throw structured error for generic errors
      throw {
        status: e.status || e.response?.status || 500,
        data: {
          message: i18n.t("something-went-wrong"),
          success: false
        }
      };
    }
  },
}

export default {
  namespaced,
  actions
}